import { useHistory } from "../../core/utils";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { API } from "../../core/api";
import { Note } from "../../components/Note";
import { Actions } from "../../store/actions";

const useLogin = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const store = useSelector((state) => state?.Store);

  const [phoneNumber, setPhoneNumber] = useState("");
  const [captcha, setCaptcha] = useState("");
  const [captchaUUID, setCaptchaUUID] = useState("");
  const [captchaImg, setCaptchaImg] = useState("");
  const [otp, setOtp] = useState(false);
  const [otpCode, setOtpCode] = useState("");

  const getCaptchaImage = () => {
    // API.get
    //     .captcha()
    //     .then((response) => {
    //         if (response.success) {
    //             setCaptcha("")
    //             setCaptchaUUID(response.data.captcha_uuid);
    //             setCaptchaImg(response.data.image_str);
    //         } else {
    //             Note.error(response.message);
    //         }
    //     })
    //     .catch((e) => {
    //         console.log(e);
    //     });
  };

  const login = () => {
    if (!phoneNumber) {
      Note.error("لطفا شماره تماس خود را وارد کنید.");
      return;
    }
    if (!captcha) {
      Note.error("لطفا کد امنیتی را وارد کنید.");
      return;
    }

    // API.post
    //   .login({ phone_number: phoneNumber, captcha, captcha_uuid: captchaUUID })
    //   .then((response) => {
    //     if (response.success) {
    //       setOtp(true);
    //       Note.success(response.message);
    //       dispatch(Actions.LoginUser(response.data));
    //       // history.push("/");
    //     } else {
    //       Note.error(response.message);
    //       getCaptchaImage();
    //       setCaptcha("");
    //     }
    //   })
    //   .catch((e) => {
    //     console.log(e);
    //   });
  };

  const loginOtp = () => {
    if (!otpCode) {
      Note.error("لطفا کد otp را وارد کنید.");
      return;
    }

    // API.post
    //   .login({ phone_number: phoneNumber, otp_code: otpCode })
    //   .then((response) => {
    //     if (response.success) {
    //       Note.success(response.message);
    //       dispatch(Actions.LoginUser({ ...response.data, ...response.extra }));
    //       history.push("/");
    //     } else {
    //       Note.error(response.message);
    //       setOtp(false);
    //       setOtpCode("");
    //     }
    //   })
    //   .catch((e) => {
    //     console.log(e);
    //   });
  };

  useEffect(() => {
    if (store.user?.is_login && store?.user?.token) {
      history.push("/");
    } else {
      getCaptchaImage();
    }
  }, [store.user?.is_login, store?.user?.token, history]);

  useEffect(() => {
    if (otpCode.length === 6) {
      loginOtp();
    }
    // eslint-disable-next-line
  }, [otpCode]);

  return {
    phoneNumber,
    setPhoneNumber,
    captcha,
    setCaptcha,
    captchaUUID,
    setCaptchaUUID,
    captchaImg,
    setCaptchaImg,
    otp,
    setOtp,
    otpCode,
    setOtpCode,
    getCaptchaImage,
    login,
    loginOtp,
  };
};

export default useLogin;
